import { formatDate } from "@/shared/utils/date-formatting";
/** All date format tokens available in user preferences. */
const DATE_FORMAT_TOKENS = [
    "DD/MM/YYYY",
    "DD MMM YYYY",
    "ddd DD MMM YYYY",
    "DD MMMM YYYY",
    "dddd DD MMMM YYYY",
    "YYYY-MM-DD",
];
/**
 * Builds the date format dropdown options with labels that show today's date
 * in each format — preview matches exactly what the user will see after selecting.
 */
export function buildDateFormatOptions(locale) {
    const today = new Date().toISOString();
    return DATE_FORMAT_TOKENS.map((token) => ({
        value: token,
        label: formatDate(today, locale, token),
    }));
}
